import { heIL } from "@material-ui/core/locale"
import { createTheme, ThemeOptions } from "@material-ui/core/styles"
import createBreakpoints from "@material-ui/core/styles/createBreakpoints"
import { Overrides } from "@material-ui/core/styles/overrides"
import { MuiPickersOverrides } from "@material-ui/pickers/typings/overrides"
import boxShadows from "./boxShadows"
import colors from "./colors"

const breakpoints = createBreakpoints({})

const muiThemeOptions: ThemeOptions = {
  direction: "rtl",
  spacing: 3,
  // ///////////////////////////////////////////////////////:
  // typography:
  typography: {
    fontFamily: "Speedee, NarkisBlockCondensed, sans-serif",
    h1: {
      color: colors.black,
      fontWeight: "bold",
      fontSize: "60px",
      lineHeight: "120%",
      letterSpacing: "-0.02em",
      textAlign: "center",
      fontFamily: "Speedee, NarkisBlock",
      // [breakpoints.up("md")]: {
      //   fontSize: "38px",
      // },
    },
    h2: {
      color: colors.black,
      fontSize: "50px",
      fontWeight: "bold",
      lineHeight: "120%",
      textAlign: "center",
      // fontSize: 20,
      // textAlign: "center",
      // fontWeight: 500,
      // letterSpacing: "0.72px",
      // margin: "16px 0",
    },
    h3: {
      color: colors.black,
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "24px",
      lineHeight: "120%",
      letterSpacing: "-0.02em",
      textAlign: "center",
      // fontSize: "0.875rem",
      // fontWeight: "normal",
      // letterSpacing: "0.56px",
      // marginTop: "24px",
      // marginBottom: "20px",
      // borderBottom: `2px solid ${colors.yellowishGreen}`,
      // paddingBottom: "8px",
      // [breakpoints.up("md")]: {
      //   fontSize: "1rem",
      // },
    },
    h4: {
      color: colors.black,
      fontStyle: "normal",
      fontWeight: "bold",
      fontSize: "26px",
      lineHeight: "auto",
      letterSpacing: "-0.02em",
      textAlign: "center",
    },
    h5: {
      fontFamily: "Speedee, NarkisBlock-Thin",
      fontWeight: 100,
    },
    body1: {
      fontSize: "20px",
      color: colors.black,
      fontStyle: "normal",
      lineHeight: "140%",
      textAlign: "center",
      fontFamily: "Speedee, NarkisBlock-Thin",
      fontWeight: 100,
    },
    body2: {
      fontSize: "24px",
      color: colors.marbleGrey,
      fontWeight: 400,
      lineHeight: "140%",
      textAlign: "center",
      fontFamily: "NarkisBlock-Thin",
    },
  },
  // ///////////////////////////////////////////////////////:
  // colors:
  palette: {
    background: {
      default: colors.white,
    },
    primary: {
      main: colors.black,
      contrastText: colors.white,
    },
    secondary: {
      main: colors.white,
      contrastText: colors.black,
    },
    text: {
      primary: colors.black,
      // secondary: colors.orange,
    },
    error: {
      main: "#b50303",
    },
  },
  props: {
    MuiContainer: {
      maxWidth: "lg",
    },
    MuiFormControl: {
      fullWidth: false,
    },
    MuiTextField: {
      fullWidth: false,
      variant: "outlined",
      autoComplete: "true",
    },

    // MuiOutlinedInput: {
    //   notched: true,
    // },
    MuiButton: {
      //   disableTouchRipple: true,
      //   disableFocusRipple: true,
      disableRipple: true,
    },
  },
}

const overrides: Overrides | MuiPickersOverrides = {
  // ///////////////////////////////////////////////////////:
  // tabs:
  MuiTabs: {
    root: {
      borderBottom: `1px solid ${colors.wheat}`,
    },
    indicator: {
      backgroundColor: colors.cherryRed,
    },
    scroller: {
      backgroundColor: colors.white,
      color: colors.black,
    },

    fixed: {
      [breakpoints.up("md")]: {
        paddingTop: "50px",
      },
    },
  },

  MuiTab: {
    root: {
      width: "max-content",
      fontSize: "14px",
      fontWeight: 400,
      padding: "9px 4px 0px",
    },

    textColorPrimary: {
      color: colors.marbleGrey,
      "&.Mui-selected": {
        color: colors.cherryRed,
      },
    },

    wrapper: {},
  },
  // ///////////////////////////////////////////////////////:
  // paper:
  MuiPaper: {
    elevation1: {
      boxShadow: "0px 1px 4px rgba(69, 37, 28, 0.15)",
      borderRadius: "16px",
      padding: "4px",
      overflow: "hidden",
    },
    elevation4: {
      boxShadow: "none",
    },
    rounded: {
      backgroundColor: "transparent",
    },
  },
  // ///////////////////////////////////////////////////////:
  // drawer:
  MuiDrawer: {
    paper: {
      paddingTop: "56px",
    },
  },
  MuiDivider: {
    root: {
      height: "2px",
      width: "calc(100% - 60px)",
      margin: "0 auto",
    },
  },
  MuiListItem: {
    gutters: {
      paddingLeft: "27px",
      paddingRight: "0",
    },
  },
  MuiContainer: {
    root: {
      paddingRight: "15px",
      paddingLeft: "15px",
      [breakpoints.up("sm")]: {
        paddingRight: "15px",
        paddingLeft: "15px",
      },
    },
  },
  // ///////////////////////////////////////////////////////:
  // popup and backdrop:
  MuiBackdrop: {
    root: {
      backgroundColor: "rgba(69, 37, 28, 0.6);",
      webkitBackdropFilter: "blur(8px)",
      backdropFilter: "blur(8px)",
    },
  },
  MuiDialog: {
    paperWidthSm: {
      borderRadius: 30,
      overflow: "hidden",
      [breakpoints.up("md")]: {
        flexDirection: "row",
        maxHeight: "100%",
      },
    },
    paperScrollPaper: {
      maxHeight: "calc(100% - 90px)",
      overflowY: "initial",
    },
    paper: {
      width: "100%",
      margin: "32px 6px;",
    },
    paperScrollBody: {
      overflow: "visible",
      margin: "50px 6px;",

      [breakpoints.down("md")]: {
        width: "calc(100% - 12px)",
        maxWidth: "100% !important",
      },
    },
  },
  MuiDialogContent: {
    root: {
      borderRadius: "5px",
      // boxShadow: "0 5px 99px 0 rgba(9, 42, 70, 0.6)",
      // border: "solid 1px #707070",
      backgroundColor: colors.white,
    },
  },
  MuiSvgIcon: {
    colorPrimary: {
      color: colors.black,
    },
  },
  // ///////////////////////////////////////////////////////:
  // buttons:
  MuiButtonBase: {
    root: {
      "&:focus-visible": {
        outline: "auto 5px -webkit-focus-ring-color !important",
      },
    },
  },
  MuiButton: {
    text: {
      padding: "none",
      width: "fit-content",
    },
    contained: {
      color: colors.black,
      backgroundColor: colors.darkYellow,
      // border: `1px solid rgba(247, 243, 235, 0.8);`,
      webkitBackdropFilter: "blur(8px)",
      backdropFilter: "blur(8px)",
      outline: null,
      padding: "12px 24px",
      boxShadow: "none",
      "&:hover": {
        backgroundColor: `#EFAD00 !important`,
        // border: "1px solid rgba(177, 17, 22, 0.8);",
        color: colors.black,
        boxShadow: "none",
      },
      "&:focus": {
        boxShadow: "none",
      },
    },
    outlined: {
      width: "fit-content",
      color: colors.cherryRed,
      backgroundColor: colors.white,
      border: `solid 2px ${colors.darkYellow};`,
      "&:hover": {
        backgroundColor: colors.white,
        border: null,
        color: colors.black,
        boxShadow: "none",
      },
    },
    outlinedSecondary: {
      color: colors.cherryRed,
      backgroundColor: "transparent",
      border: `1px solid ${colors.cherryRed}`,
      "&:hover": {
        color: colors.white,
        backgroundColor: "transparent",
        border: null,
        boxShadow: "none",
      },
    },
    sizeSmall: {
      padding: "2px 8px",
      fontSize: "14px",
      fontWeight: 400,
      minHeight: "0px",
      minWidth: "0px",
      height: "fit-content",
    },
    root: {
      backgroundColor: "rgba(177, 17, 22, 0.8)",
      // border: `1px solid rgba(177, 17, 22, 0.8)`,
      borderRadius: "0px",
      fontSize: "26px",
      lineHeight: "26px",
      letterSpacing: "0.02em",
      color: colors.flour,
      fontWeight: "bold",
      fontFamily: "Speedee, NarkisBlock",

      [breakpoints.down("sm")]: {
        fontSize: "20px",
      },
      "&:hover": {
        backgroundColor: "rgba(177, 17, 22, 0.9);",
        // border: `1px solid rgba(177, 17, 22, 0.9);`,
      },
      "&:disabled": {
        backgroundColor: "#e5e5e5",
        color: "#757575",
      },

      "&:focus-visible": {
        outline: "auto 5px -webkit-focus-ring-color",
      },

      // backgroundColor: "rgba(177, 17, 22, 0.8);",
      // borderRadius: 1,
      // fontWeight: "bold",
      // fontSize: "16px",
      // [breakpoints.down("sm")]: {
      //   width: "100%",
      //   padding: "10px 0",
      // },
      // [breakpoints.up("md")]: {
      //   padding: "10px 60px",
      //   // marginTop: "20px",
      //   fontSize: "20px",
      // },
      // boxShadow: null,
      // "&:hover": {
      //   boxShadow: null,
      // },
    },
    label: {
      textAlign: "center",
    },
  },
  // ///////////////////////////////////////////////////////:
  // Accordion:
  MuiAccordion: {
    root: {
      border: "1.5px solid white",
      minHeight: "0px",
      boxShadow: "none",
      "&:not(:last-child)": {
        borderBottom: 0,
      },
      "&:before": {
        display: "none",
      },
      "&$expanded": {
        margin: "auto",
      },
    },
    rounded: {
      "&:last-child": {
        borderBottomRightRadius: "16px",
        borderBottomLeftRadius: "16px",
        overflow: "hidden",
      },
      "&:first-child": {
        borderTopRightRadius: "16px",
        borderTopLeftRadius: "16px",
        overflow: "hidden",
      },
    },
    expanded: {},
  },
  MuiAccordionDetails: {
    root: {
      flexWrap: "wrap",
      padding: "8px 15px",
      // [breakpoints.up("md")]: {
      //   padding: "8px 15px",
      // },
    },
  },
  MuiAccordionSummary: {
    root: {
      minHeight: "0px",
      backgroundColor: colors.flour,
      padding: "0px",
      "&$expanded": {
        minHeight: "0px",
      },
    },
    content: {
      margin: "0px",
      padding: "14px 15px",
      alignItems: "center",
      "&$expanded": {
        margin: "0px",
        padding: "14px 15px",
        alignItems: "center",
      },
    },
    expandIcon: {
      "&$expanded": {
        transform: "scaleY(-1)",
      },
    },
  },
  // ///////////////////////////////////////////////////////:
  // forms elements:
  // regular input:
  MuiFormControl: {
    root: {
      borderRadius: "16px",
    },
  },

  MuiInput: {
    input: {
      borderRadius: 0,
      height: "40px",
      boxSizing: "border-box",
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: "blue",
        fontSize: 14,
        fontFamily: "Speedee, NarkisBlockCondensed, sans-serif",
      },
    },
    root: {
      "&$disabled": {
        color: colors.flour,
      },
    },
  },
  // datepicker:
  MuiPopover: { paper: { backgroundColor: colors.white } },

  MuiOutlinedInput: {
    input: {
      padding: "13px 16px",
      "&::placeholder": {
        textOverflow: "ellipsis !important",
        color: colors.marbleGrey,
        fontSize: 15,
        fontFamily: "Speedee, NarkisBlockCondensed, sans-serif",
      },
    },
    root: {
      backgroundColor: "#f7f7f7",
      boxShadow: "inset 0px 2px 2px -1px rgba(74, 74, 104, 0.1)",
      color: colors.darkGrey,
      fontSize: 15,
      height: "50px",
      "& legend": {
        fontWeight: "normal",
        fontSize: "15px",
        position: "absolute",
      },
      "&::placeholder": { color: colors.marbleGrey, fontSize: 14 },
      "& $notchedOutline": {
        borderColor: colors.transparent,
        borderWidth: 1.5,
        top: 0,
        bottom: 0,
      },

      "&:hover $notchedOutline": {
        borderColor: colors.darkGrey,
        borderWidth: 1.5,
        top: -1,
        bottom: -1,
        left: -1,
        right: -1,
      },

      "&$focused $notchedOutline": {
        borderColor: colors.transparent,
        borderWidth: 1,
        boxShadow: "0px 0px 0px 1.5px rgba(69, 37, 28, 0.25)",
      },
      "&$error $notchedOutline": {
        borderColor: colors.transparent,
        boxShadow: "0px 0px 0px 3.2px rgba(171, 78, 78, 0.25)",
        borderWidth: 1.5,
        top: -1,
        bottom: -1,
        left: -1,
        right: -1,
        color: colors.black,
      },
      "&$error": {
        backgroundColor: colors.white,
        boxShadow: "none",
      },
      "&$focused": {
        backgroundColor: colors.white,
        boxShadow: "none",
      },
    },
  },
  MuiInputAdornment: {
    root: {
      color: colors.black,
    },
  },
  // forms labels:
  MuiInputLabel: {
    root: {
      backgroundColor: "transparent",
      direction: "rtl",
      fontSize: "20px",
      color: "#757575",
    },
    outlined: {
      transform: "translate(21px, 16px) scale(1)",
      [breakpoints.up("md")]: {
        transform: "translate(21px, 6px) scale(1)",
      },
      legend: {
        fontWeight: "bold",
        fontSize: "14px",
        [breakpoints.up("md")]: {
          fontSize: "16px",
        },
      },
      "&$shrink": {
        transform: "translate(0px, -26px) scale(1)",
        color: "#000",
        fontSize: "18px",
        [breakpoints.up("md")]: {
          transform: "translate(0px, -28px) scale(1)",
        },
      },
    },
  },

  MuiFormLabel: {
    root: {
      flexBasis: "100%",
      direction: "rtl",
      // color: colors.warmGrey,
      fontWeight: "normal",
      fontSize: "14px",
      lineHeight: 1.14,
      [breakpoints.up("md")]: {
        fontSize: "16px",
        lineHeight: 1.36,
      },

      "&$focused": {
        color: colors.black,
        "& .MuiFormLabel-asterisk": {
          color: colors.cherryRed,
        },
      },

      "&$error": {
        color: colors.red,
      },
    },
    asterisk: {
      marginLeft: "2px",
      verticalAlign: "top",
      color: colors.cherryRed,
      [breakpoints.up("md")]: {
        fontSize: "18px",
      },
    },
  },

  MuiFormControlLabel: {
    root: {
      alignItems: "flex-start",
      ".MuiFormGroup-root &": {
        display: "inline-block",
        marginRight: "0",
        marginLeft: "0",
        "& .MuiButtonBase-root": {
          display: "none",
        },
      },
    },
  },
  MuiSwitch: {
    root: {
      width: 28,
      height: 16,
      padding: 0,
      display: "flex",
    },
    switchBase: {
      padding: 2,
      color: colors.sand,
      "&$checked": {
        transform: "translateX(12px)",
      },
    },
    thumb: {
      width: 12,
      height: 12,
      boxShadow: "none",
    },
    colorSecondary: {
      "&$checked": {
        // Controls checked color for the thumb
        color: colors.white,
      },
    },
    track: {
      border: `1px solid ${colors.sand}`,
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor: colors.white,
      "$checked$checked + &": {
        // Controls checked color for the track
        border: `1px solid ${colors.cherryRed}`,
        opacity: 1,
        backgroundColor: colors.cherryRed,
      },
    },
  },
  // checkbox
  MuiCheckbox: {
    colorSecondary: {
      color: colors.sand,
      "&$checked": {
        color: "rgba(177, 17, 22, 0.8);",
      },
    },
  },
  // radio:
  MuiRadio: {
    colorSecondary: {
      // backgroundColor: colors.sand,
      color: colors.sand,
      "&$checked": {
        color: "rgba(177, 17, 22, 0.8);",
        // "& input + *": {
        //   backgroundColor: colors.sand,
        // },
      },
    },
  },
  // dropdown (select):
  MuiMenu: {
    paper: {
      background: colors.white,
    },
  },
  // dropdown item (list:)
  MuiMenuItem: {
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      background: "white",
      "&": {
        fontSize: 15,
        paddingTop: 4,
        paddingBottom: 4,
        paddingRight: 16,
        paddingLeft: 16,
        minHeight: "25px;",
      },
      "&:hover": {
        background: "rgba(247, 243, 235, 0.4);",
      },
      "&.Mui-selected": {
        background: colors.flour,
      },
      "&.Mui-selected:hover": {
        background: "rgba(247, 243, 235, 0.4);",
      },
    },
  },
  MuiFormHelperText: {
    root: {
      marginTop: "3px",
      marginRight: "0px !important",
      marginLeft: "0px !important",
      "&$error": {
        color: colors.red,
        textAlign: "start",
        fontSize: "20px",
      },
    },
  },
  // ///////////////////////////////////////////////////////:
  // datepicker:

  MuiPickersDatePickerRoot: {
    toolbar: {
      backgroundColor: colors.cherryRed,
      flexDirection: "row-reverse",
      alignItems: "center",
      justifyContent: "space-between",
      height: "auto",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  MuiPickersDay: {
    day: {
      color: colors.darkGrey,
      "&:hover": {
        backgroundColor: "rgba(247, 243, 235, 0.8);",
      },
    },
    daySelected: {
      color: colors.white,
      backgroundColor: "rgba(177, 17, 22, 0.8);",
      "&:hover": {
        backgroundColor: colors.cherryRed,
      },
    },
    dayDisabled: {
      color: colors.flour,
    },
    current: {
      color: colors.cherryRed,
    },
  },
  MuiAvatar: {
    root: {
      width: 24,
      height: 24,
      marginBottom: "0 !important",
    },
    img: {
      objectFit: "contain",
    },
  },
}
muiThemeOptions.overrides = overrides

const theme = {
  ...createTheme(muiThemeOptions, heIL),
  colors,
  boxShadows,
}

export default theme

export type Theme = typeof theme
